import Layout from '@/layout';

export default {
  path: '/dashboard',
  component: Layout,
  meta: {
    title: '首页',
    icon: 'iconfont icon-home',
    code: '010201'
  },
  children: [
    {
      path: '',
      component: () => import('@/views/dashboard/index2.vue'),
      meta: {
        noPadding: true
      }
    },
    {
      path: '*',
      component: () => import('@/views/404')
    }
  ]
};
